import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Compass } from 'lucide-react';
import Header from '../components/Layout/Header';

/** The catch-all route: any address the router does not know. */
const NotFoundPage = () => {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = 'Page not found · iVisora';
    const robots = document.createElement('meta');
    robots.name = 'robots';
    robots.content = 'noindex';
    document.head.appendChild(robots);
    return () => {
      document.title = previousTitle;
      robots.remove();
    };
  }, []);

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <Header />
      <main className="flex-1 flex items-center justify-center p-6">
        <div className="bg-white rounded-3xl shadow-xl p-10 max-w-md w-full text-center">
          <div className="w-16 h-16 bg-purple-50 rounded-full flex items-center justify-center mx-auto mb-6">
            <Compass className="w-8 h-8 text-purple-600" aria-hidden="true" />
          </div>
          <h1 className="text-2xl font-bold text-gray-900 mb-3">Page not found</h1>
          <p className="text-gray-500 mb-8">
            The page you’re looking for doesn’t exist or has moved.
          </p>
          <div className="space-y-3">
            <Link
              to="/templates"
              className="w-full h-12 bg-purple-600 hover:bg-purple-700 text-white font-semibold rounded-xl transition-colors flex items-center justify-center"
            >
              Browse templates
            </Link>
            <Link
              to="/"
              className="w-full h-12 border border-gray-200 rounded-xl font-semibold text-gray-700 hover:bg-gray-50 transition-colors flex items-center justify-center"
            >
              Go to the home page
            </Link>
          </div>
        </div>
      </main>
    </div>
  );
};

export default NotFoundPage;
